import React, { useState } from 'react';
import { Card, CardMedia, CardContent, Typography, Box, Button, Rating, Stack, Chip, Dialog, IconButton, Menu, MenuItem, Snackbar, Alert } from '@mui/material';
import { Phone, WhatsApp, Email, LocalPhone, Close, Share } from '@mui/icons-material';
import { buildImageUrl } from '../config/apiConfig';
import ServiceDetailModal from './ServiceDetailModal';

const ServiceCard = ({ service }) => {
  const [imageError, setImageError] = useState(false);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openDetailModal, setOpenDetailModal] = useState(false);

  if (!service) return null;

  const categoryConfig = {
    'band-baja': { color: '#FF6B6B', bgColor: '#FFE5E5', icon: '🎺', gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%)' },
    'barber': { color: '#FF9F43', bgColor: '#FFF5E6', icon: '💇', gradient: 'linear-gradient(135deg, #FF9F43 0%, #FFB366 100%)' },
    'bike': { color: '#0984E3', bgColor: '#E6F3FF', icon: '🏍️', gradient: 'linear-gradient(135deg, #0984E3 0%, #40B0FF 100%)' },
    'building-material': { color: '#E67E22', bgColor: '#FFEBDB', icon: '🏗️', gradient: 'linear-gradient(135deg, #E67E22 0%, #F39C12 100%)' },
    'bus': { color: '#1565C0', bgColor: '#E3F2FD', icon: '🚌', gradient: 'linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)' },
    'buysell-other': { color: '#00897B', bgColor: '#E0F2F1', icon: '🛒', gradient: 'linear-gradient(135deg, #00897B 0%, #26C6DA 100%)' },
    'cab': { color: '#F1C40F', bgColor: '#FFF8E1', icon: '🚕', gradient: 'linear-gradient(135deg, #F1C40F 0%, #F7DC6F 100%)' },
    'carpenter': { color: '#795548', bgColor: '#EFEBE9', icon: '🪵', gradient: 'linear-gradient(135deg, #795548 0%, #A1887F 100%)' },
    'catering': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🍽️', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'contact-us': { color: '#7B1FA2', bgColor: '#F3E5F5', icon: '📞', gradient: 'linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%)' },
    'delivery-boy': { color: '#00695C', bgColor: '#E0F2F1', icon: '🚴', gradient: 'linear-gradient(135deg, #00695C 0%, #00897B 100%)' },
    'doctor': { color: '#D32F2F', bgColor: '#FFEBEE', icon: '⚕️', gradient: 'linear-gradient(135deg, #D32F2F 0%, #E53935 100%)' },
    'driver': { color: '#455A64', bgColor: '#ECEFF1', icon: '🚗', gradient: 'linear-gradient(135deg, #455A64 0%, #607D8B 100%)' },
    'e-rickshaw': { color: '#00897B', bgColor: '#E0F2F1', icon: '🛺', gradient: 'linear-gradient(135deg, #00897B 0%, #4DB6AC 100%)' },
    'electrician': { color: '#FFB300', bgColor: '#FFF3E0', icon: '⚡', gradient: 'linear-gradient(135deg, #FFB300 0%, #FFD54F 100%)' },
    'emergency': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🚨', gradient: 'linear-gradient(135deg, #E91E63 0%, #F50057 100%)' },
    'gardner': { color: '#2E7D32', bgColor: '#E8F5E9', icon: '🌿', gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)' },
    'gas': { color: '#6A1B9A', bgColor: '#F3E5F5', icon: '⛽', gradient: 'linear-gradient(135deg, #6A1B9A 0%, #8E24AA 100%)' },
    'health-other': { color: '#0288D1', bgColor: '#E1F5FE', icon: '💊', gradient: 'linear-gradient(135deg, #0288D1 0%, #4FC3F7 100%)' },
    'labour': { color: '#E64A19', bgColor: '#FFEBEE', icon: '👷', gradient: 'linear-gradient(135deg, #E64A19 0%, #FF6F4A 100%)' },
    'mantainence-other': { color: '#827717', bgColor: '#F9F6F0', icon: '🔧', gradient: 'linear-gradient(135deg, #827717 0%, #9FA725 100%)' },
    'medical': { color: '#C2185B', bgColor: '#FCE4EC', icon: '🏥', gradient: 'linear-gradient(135deg, #C2185B 0%, #E91E63 100%)' },
    'moto-mech': { color: '#212121', bgColor: '#F5F5F5', icon: '🔩', gradient: 'linear-gradient(135deg, #212121 0%, #424242 100%)' },
    'music-dj': { color: '#AA00FF', bgColor: '#F3E5F5', icon: '🎵', gradient: 'linear-gradient(135deg, #AA00FF 0%, #D500F9 100%)' },
    'new': { color: '#388E3C', bgColor: '#E8F5E9', icon: '⭐', gradient: 'linear-gradient(135deg, #388E3C 0%, #66BB6A 100%)' },
    'other': { color: '#78909C', bgColor: '#ECEFF1', icon: '📌', gradient: 'linear-gradient(135deg, #78909C 0%, #90A4AE 100%)' },
    'painter': { color: '#FF6B9D', bgColor: '#FFE5F0', icon: '🎨', gradient: 'linear-gradient(135deg, #FF6B9D 0%, #FF8FB3 100%)' },
    'pandit-ji': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🙏', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'plumber': { color: '#00897B', bgColor: '#E0F2F1', icon: '🔧', gradient: 'linear-gradient(135deg, #00897B 0%, #4DB6AC 100%)' },
    'potter': { color: '#6D4C41', bgColor: '#EFEBE9', icon: '🏺', gradient: 'linear-gradient(135deg, #6D4C41 0%, #8D6E63 100%)' },
    'raj-mistri': { color: '#E67E22', bgColor: '#FFEBDB', icon: '👷', gradient: 'linear-gradient(135deg, #E67E22 0%, #F39C12 100%)' },
    'restaurants': { color: '#E91E63', bgColor: '#FCE4EC', icon: '🍴', gradient: 'linear-gradient(135deg, #E91E63 0%, #F06292 100%)' },
    'teacher': { color: '#2196F3', bgColor: '#E3F2FD', icon: '👨‍🏫', gradient: 'linear-gradient(135deg, #2196F3 0%, #42A5F5 100%)' },
    'tent-house': { color: '#FF9800', bgColor: '#FFE0B2', icon: '⛺', gradient: 'linear-gradient(135deg, #FF9800 0%, #FFB74D 100%)' },
    'water': { color: '#0097A7', bgColor: '#E0F2F1', icon: '💧', gradient: 'linear-gradient(135deg, #0097A7 0%, #00BCD4 100%)' },
  };

  const categoryLower = (service.field || 'other').toLowerCase().replace(/\s+/g, '-');
  const config = categoryConfig[categoryLower] || categoryConfig['other'];

  // ✅ Use buildImageUrl from API config
  const getImageUrl = () => {
    if (!service.photo) {
      console.log('⚠️ No photo field in service');
      return null;
    }

    const photo = service.photo.trim();
    console.log('🖼️ Raw photo value from API:', photo);

    // ✅ Use buildImageUrl helper
    const url = buildImageUrl(photo, 'experts');
    console.log('📸 Built image URL:', url);
    return url;
  };

  const imageUrl = getImageUrl();

  const handleImageError = (e) => {
    console.error('❌ Image failed to load:', imageUrl,e);
    setImageError(true);
  };

  const handleCall = (phone) => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleWhatsApp = (phone) => {
    if (phone) {
      const message = `Hi, I'm interested in your ${service.field} services.`;
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
    }
  };

  const handleEmail = () => {
    if (service.email) {
      window.location.href = `mailto:${service.email}`;
    }
  };

  const handleImageClick = () => {
    if (imageUrl && !imageError) {
      setOpenImageDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenImageDialog(false);
  };

  const handleShareClick = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleShareClose = () => {
    setShareAnchorEl(null);
  };

  const generateShareText = () => {
    return `Check out ${service.name} - ${service.field} service provider in Bisauli\n📍 ${service.address}\n📱 ${service.phone1}${service.phone2 && service.phone2 !== service.phone1 ? ', ' + service.phone2 : ''}${service.rate ? '\n💰 Rate: ₹' + service.rate : ''}\n\n${service.note || ''}`;
  };

  const handleShareWhatsApp = () => {
    const text = encodeURIComponent(generateShareText());
    window.open(`https://wa.me/?text=${text}`, '_blank');
    setSnackbarMessage('✅ Shared on WhatsApp!');
    setSnackbarOpen(true);
    handleShareClose();
  };

  const handleShareEmail = () => {
    const subject = encodeURIComponent(`Check out: ${service.name} - ${service.field}`);
    const body = encodeURIComponent(generateShareText());
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
    setSnackbarMessage('📧 Opening email client...');
    setSnackbarOpen(true);
    handleShareClose();
  };

  const handleShareCopy = () => {
    navigator.clipboard.writeText(generateShareText());
    setSnackbarMessage('✅ Profile copied to clipboard!');
    setSnackbarOpen(true);
    handleShareClose();
  };

  const handleShareNative = () => {
    if (navigator.share) {
      navigator.share({
        title: service.name,
        text: generateShareText(),
        url: window.location.href
      }).catch(err => console.log('Error sharing:', err));
    }
    handleShareClose();
  };

  return (
    <>
      <Card 
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          transition: 'all 0.3s ease',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(102, 126, 234, 0.2)',
            transform: 'translateY(-4px)'
          }
        }}
      >
        {/* Image Section */}
        <Box
          onClick={handleImageClick}
          sx={{
            height: 200,
            backgroundColor: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            position: 'relative',
            cursor: imageUrl && !imageError ? 'pointer' : 'default',
            '&:hover': imageUrl && !imageError ? {
              filter: 'brightness(0.9)',
            } : {}
          }}
        >
          {imageUrl && !imageError ? (
            <CardMedia
              component="img"
              height="200"
              image={imageUrl}
              alt={service.name || 'Service'}
              onError={handleImageError}
              sx={{ 
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                userSelect: 'none'
              }}
            />
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                background: config.gradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '3rem'
              }}
            >
              {config.icon}
            </Box>
          )}
        </Box>

        {/* Content */}
        <CardContent sx={{ flexGrow: 1, pb: 1 }}>
          {/* Title with Share Button */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#2d3748', flex: 1 }}>
              {service.name || 'Service'}
            </Typography>
            <IconButton
              size="small"
              onClick={handleShareClick}
              sx={{
                color: '#667eea',
                '&:hover': { backgroundColor: 'rgba(102, 126, 234, 0.1)' }
              }}
            >
              <Share fontSize="small" />
            </IconButton>
          </Box>

          {/* Share Menu */}
          <Menu
            anchorEl={shareAnchorEl}
            open={Boolean(shareAnchorEl)}
            onClose={handleShareClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleShareWhatsApp}>
              <WhatsApp sx={{ mr: 1, color: '#25D366' }} fontSize="small" />
              Share on WhatsApp
            </MenuItem>
            <MenuItem onClick={handleShareEmail}>
              <Email sx={{ mr: 1, color: '#667eea' }} fontSize="small" />
              Share via Email
            </MenuItem>
            <MenuItem onClick={handleShareCopy}>
              Share Profile Text
            </MenuItem>
            {navigator.share && (
              <MenuItem onClick={handleShareNative}>
                More Options
              </MenuItem>
            )}
          </Menu>

          {/* Category/Field Chip */}
          <Chip 
            label={service.field || 'Other'} 
            size="small" 
            sx={{ 
              background: config.gradient,
              color: '#fff',
              fontWeight: 600,
              mb: 1
            }} 
          />

          {/* Description/Note */}

          {/* Location */}

          {/* Phone Numbers */}
          <Box sx={{ mb: 1.5 }}>
            {service.phone1 && (
              <Typography 
                variant="caption" 
                sx={{ color: '#667eea', display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, fontSize: '0.8rem', fontWeight: 600 }}
              >
                <LocalPhone sx={{ fontSize: '0.9rem' }} />
                {service.phone1}
              </Typography>
            )}
          </Box>

          {/* Rating */}
          {service.rating && (
            <Box sx={{ mb: 1 }}>
              <Rating value={parseFloat(service.rating) || 0} readOnly size="small" />
            </Box>
          )}
        </CardContent>

        {/* Contact Actions */}
        <Box sx={{ px: 2, pb: 2 }}>
          <Stack direction="row" spacing={1}>
            {service.phone1 && (
              <>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleWhatsApp(service.phone1)}
                  sx={{
                    background: '#25D366',
                    color: '#fff',
                    flex: 1,
                    fontSize: '0.75rem',
                    py: 0.75,
                    '&:hover': { background: '#1fbb4f' }
                  }}
                  startIcon={<WhatsApp />}
                >
                  Chat
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleCall(service.phone1)}
                  sx={{
                    color: '#667eea',
                    borderColor: '#667eea',
                    flex: 1,
                    fontSize: '0.75rem',
                    py: 0.75,
                    '&:hover': { borderColor: '#667eea', bgcolor: 'rgba(102, 126, 234, 0.05)' }
                  }}
                  startIcon={<Phone />}
                >
                  Call
                </Button>
              </>
            )}
            {service.email && (
              <Button
                size="small"
                variant="outlined"
                onClick={handleEmail}
                sx={{
                  color: '#667eea',
                  borderColor: '#667eea',
                  flex: 1,
                  fontSize: '0.75rem',
                  py: 0.75,
                  '&:hover': { borderColor: '#667eea', bgcolor: 'rgba(102, 126, 234, 0.05)' }
                }}
                startIcon={<Email />}
              >
                Email
              </Button>
            )}
            {/* Add View Details Button */}
            <Button
              size="small"
              variant="contained"
              onClick={() => setOpenDetailModal(true)}
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                flex: 1,
                fontSize: '0.75rem',
                py: 0.75,
                fontWeight: 700,
                '&:hover': { boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)' }
              }}
            >
              Details
            </Button>
          </Stack>
        </Box>
      </Card>

      {/* Image Expansion Dialog */}
      <Dialog
        open={openImageDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#000',
            borderRadius: '12px'
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            backgroundColor: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '500px'
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)'
              },
              zIndex: 1
            }}
          >
            <Close />
          </IconButton>

          {/* Expanded Image */}
          <img
            src={imageUrl}
            alt={service.name || 'Service'}
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
              padding: '20px'
            }}
          />

          {/* Service Info */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
              color: '#fff',
              padding: '20px',
              textAlign: 'center'
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
              {service.name}
            </Typography>
            <Typography variant="body2" sx={{ color: '#ccc' }}>
              {service.field}
            </Typography>
          </Box>
        </Box>
      </Dialog>

      {/* Snackbar for Share Feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <ServiceDetailModal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        service={service}
      />
    </>
  );
};

export default ServiceCard;